<template>
  <div class="done">
    <h2 class="done__title done__title__uppercase">
      {{ $t('done.titles.page') }}
    </h2>
    <div class="done__text">
      Votre recherche de déménageurs professionnels a bien été prise en compte.
      Vous allez ainsi bénéficier de notre accompagnement personnalisé afin
      d’organiser votre déménagement en toute tranquillité.
    </div>
    <h3 class="done__title">
      Nous allons vous contacter dans les plus brefs délais.
    </h3>
    <div class="done__text">
      <p>
        Un de nos experts en déménagement vous contactera par
        téléphone afin de finaliser votre projet de déménagement.
        Cette étape est indispensable pour vous transmettre des
        devis fermes et définitifs.
      </p>
      <p>
        Nous vous accompagnons jusqu’à votre emménagement
        pour nous assurer de votre entière satisfaction.
        Pour rappel, notre service est entièrement gratuit et
        sans engagement. Vous avez donc toutes les raisons d’en profiter !
      </p>
    </div>
    <h3 class="done__title">
      Nos garanties pour un déménagement en toute sérénité
    </h3>
    <div class="done__garanties">
      <div class="done__garanties__col">
        <el-card class="done__garanties__card">
          <img class="done__garanties__img" :src="`${cdnUrl}img/expert-dedie.png`">
          <h4 class="done__garanties__title">
            <span class="middle-align-text">Expert dédié<br/>à votre écoute</span>
          </h4>
          <ul>
            <li>Interlocuteur unique</li>
            <li>Conseils personnalisés</li>
            <li>Gain de temps</li>
          </ul>
        </el-card>
      </div>
      <div class="done__garanties__col">
        <el-card class="done__garanties__card">
          <img class="done__garanties__img" :src="`${cdnUrl}img/tarifs-garantis.png`">
          <h4 class="done__garanties__title">Tarifs compétitifs<br/>et garantis</h4>
          <ul>
            <li>Accompagnement gratuit</li>
            <li>Mise en concurrence élargie</li>
            <li>Aucun surcoût</li>
          </ul>
        </el-card>
      </div>
      <div class="done__garanties__col">
        <el-card class="done__garanties__card">
          <img class="done__garanties__img" :src="`${cdnUrl}img/qualite-demenageurs.png`">
          <h4 class="done__garanties__title">Déménageurs<br/>de qualité</h4>
          <ul>
            <li>Professionnels certifiés</li>
            <li>Sélection de devis</li>
            <li>Suivi qualité</li>
          </ul>
        </el-card>
      </div>
    </div>
    <h3 class="done__title">
      Notre priorité ? Votre satisfaction
    </h3>
    <el-card class="done__trustpilot_card">
      <trustpilot  />
    </el-card>
  </div>
</template>

<script>
import Trustpilot from '@/components/utils/Trustpilot.vue';

export default {
  name: 'Done',
  components: {
    Trustpilot,
  },
  data() {
    return {
      cdnUrl: 'https://cdn.nextories.com/static/',
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
  .done {
    max-width: 920px;
    margin-bottom: 20px;

    &__title {
      font-weight: $--font-weight-600;
      &__uppercase {
        text-transform: uppercase;
      }
    }

    &__trustpilot_card {
      margin: 20px auto;
      max-width: 300px;
      @include breakpoint(tablet) {
        max-width: unset;
        margin: 20px;
      }
    }
    &__garanties {
      display: flex;
      width: 100%;
      flex-direction: column;

      @include breakpoint(tablet) {
        flex-direction: row;
      }

      &__card {
        margin: 20px auto;
        max-width: 300px;

        @include breakpoint(tablet) {
          margin: 20px;
        }
      }

      &__col {
        flex: 1 0 33%;
        align-items: center;
        justify-items: center;
        text-align: center;

        ul {
          margin: 0;
          padding: 0;
          list-style: none;
        }
      }
    }
  }
</style>
